/**
 * CLC TA API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LocationCategory = {
    TownOrCity: 'TownOrCity',
    Country: 'Country',
    Overseas: 'Overseas'
} as const;
export type LocationCategory = typeof LocationCategory[keyof typeof LocationCategory];

